import { Compass, BadgeCheck, FileCheck2, HeartHandshake } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { ABOUT_HIGHLIGHTS, IMAGES } from "@/data/content";

const ICONS = { Compass, BadgeCheck, FileCheck2, HeartHandshake };

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-[#FBF9F5] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal y={40}>
            <div className="relative">
              <div
                aria-hidden="true"
                className="absolute -top-5 -left-5 h-full w-full rounded-2xl border border-[#C5A059]/50"
              />
              <div className="relative overflow-hidden rounded-2xl h-[420px] md:h-[540px]">
                <img
                  src={IMAGES.about}
                  alt="Container port at golden hour"
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B192C]/35 to-transparent" />
              </div>
              <div className="absolute -bottom-7 -right-4 md:-right-7 bg-[#0B192C] text-white rounded-xl px-7 py-5 shadow-[0_20px_45px_-15px_rgba(11,25,44,0.45)]">
                <p className="text-[11px] uppercase tracking-[0.24em] text-[#C5A059] font-semibold">
                  Trivena Exim LLP
                </p>
                <p className="mt-1 font-serif text-xl leading-snug">
                  Import · Export · Logistics
                </p>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <Overline>About Us</Overline>
              <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.9rem] tracking-tight leading-[1.12] text-[#0B192C]">
                About Trivena Exim LLP
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <div data-testid="about-copy" className="mt-7 space-y-5 text-base sm:text-lg text-[#475569] leading-relaxed">
                <p>
                  We provide efficient and reliable warehousing and logistics solutions to clients
                  across various industries, including agriculture, textiles, chemicals and
                  pharmaceuticals.
                </p>
                <p>
                  Our experienced and qualified professionals handle key aspects of import and
                  export documentation, customs clearance, cargo handling and transportation.
                </p>
                <p>
                  Our mission is to provide value-driven service to our customers and partners while
                  growing and expanding in a competitive and dynamic market.
                </p>
                <p>
                  We also assist with customs and GST-related matters and undertake importing,
                  exporting, wholesale, retail and distribution activities.
                </p>
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ABOUT_HIGHLIGHTS.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={0.1 * i}>
                <div
                  data-testid={`about-highlight-${i}`}
                  className="group h-full bg-white rounded-2xl border border-[#E2E8F0]/80 p-7 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(11,25,44,0.18)] hover:border-[#C5A059]/40"
                >
                  <div className="h-11 w-11 rounded-full bg-[#F4EFE6] text-[#B38C44] flex items-center justify-center transition-colors duration-500 group-hover:bg-[#0B192C] group-hover:text-[#C5A059]">
                    <Icon className="w-5 h-5" strokeWidth={1.8} />
                  </div>
                  <h3 className="mt-5 font-serif text-xl text-[#0B192C] tracking-tight">{item.title}</h3>
                  <p className="mt-2.5 text-sm text-[#475569] leading-relaxed">{item.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
